/* Beef shares (Half/Quarter Cow): interactions + PostHog measurement.
   Events (all prefixed beef_share_, all carry mode + page):
     beef_share_view                 page/section loaded
     beef_share_section_seen         {section}   first time a block scrolls into view
     beef_share_scroll               {depth}     25/50/75/100, once each
     beef_share_toggle               {share}     quarter/half cut-list toggle
     beef_share_cta_click            {cta, share} any CTA/anchor with data-rm-cta
     beef_share_faq_open             {question}
     beef_share_add_to_cart          {share, variant_id, price}
     beef_share_add_to_cart_error    {share, message}
     beef_share_bnpl_seen            {placement} Shop Pay Installments messaging rendered + in view
     beef_share_bnpl_click           {placement} clicked into the instalments prequalification modal
*/
(function () {
  var root = document.querySelector('[data-rm-beef-shares]');
  if (!root) return;
  var mode = root.getAttribute('data-mode') || 'full';

  function track(ev, props) {
    try {
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture(ev, Object.assign({ mode: mode, page: location.pathname }, props || {}));
      }
    } catch (e) {}
  }

  track('beef_share_view');

  /* Section visibility (once each) */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.getAttribute('data-rm-section');
        if (seen[name]) return;
        seen[name] = true;
        track('beef_share_section_seen', { section: name });
      });
    }, { threshold: 0.35 });
    root.querySelectorAll('[data-rm-section]').forEach(function (el) { io.observe(el); });
  }

  /* Scroll depth (page-level, once per threshold) */
  var marks = [25, 50, 75, 100], fired = {};
  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var pct = Math.round(((window.scrollY || doc.scrollTop) / max) * 100);
    marks.forEach(function (m) {
      if (pct >= m && !fired[m]) { fired[m] = true; track('beef_share_scroll', { depth: m }); }
    });
    if (fired[100]) window.removeEventListener('scroll', onScroll);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Quarter / Half cut-list toggle */
  var toggles = root.querySelectorAll('[data-rm-toggle]');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var share = btn.getAttribute('data-rm-toggle');
      toggles.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
      root.querySelectorAll('[data-rm-cuts]').forEach(function (list) {
        list.hidden = list.getAttribute('data-rm-cuts') !== share;
      });
      track('beef_share_toggle', { share: share });
    });
  });

  /* CTA clicks (anchors / links) */
  root.querySelectorAll('[data-rm-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      track('beef_share_cta_click', { cta: el.getAttribute('data-rm-cta'), share: el.getAttribute('data-share') || null });
      /* hero/footer anchors: also pre-select the matching cut list */
      var share = el.getAttribute('data-share');
      if (share && el.getAttribute('href') === '#rm-bs-cards') {
        var card = root.querySelector('.rm-bs__card[data-share="' + share + '"]');
        if (card) { card.classList.add('is-highlight'); setTimeout(function () { card.classList.remove('is-highlight'); }, 1600); }
      }
    });
  });

  /* Shop Pay Installments messaging.
     The widget itself is Shopify's <shopify-payment-terms> custom element, rendered inside
     [data-rm-bnpl]. It loads asynchronously and stays empty when the variant is not
     eligible, so "seen" only fires once the element actually has content. Clicking it opens
     Shopify's own prequalification modal, which we cannot see into, so the click is the
     furthest downstream signal available here. */
  var bnplSeen = {};
  function bnplHasContent(host) {
    var w = host.querySelector('shopify-payment-terms');
    if (!w) return host.hasAttribute('data-rm-bnpl') && !host.querySelector('form');
    return (w.shadowRoot ? w.shadowRoot.textContent : w.textContent || '').trim().length > 0;
  }
  function watchBnpl(host) {
    var placement = host.getAttribute('data-rm-bnpl');
    if ('IntersectionObserver' in window) {
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || bnplSeen[placement]) return;
          if (!bnplHasContent(host)) return;
          bnplSeen[placement] = true;
          track('beef_share_bnpl_seen', { placement: placement });
          bio.disconnect();
        });
      }, { threshold: 0.5 });
      bio.observe(host);
      /* the widget can render after first intersection, so re-check for a short while */
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (bnplSeen[placement] || tries > 20) { clearInterval(poll); return; }
        var r = host.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0 && bnplHasContent(host)) {
          bnplSeen[placement] = true;
          track('beef_share_bnpl_seen', { placement: placement });
          clearInterval(poll);
        }
      }, 500);
    }
    host.addEventListener('click', function () {
      track('beef_share_bnpl_click', { placement: placement });
    });
  }
  root.querySelectorAll('[data-rm-bnpl]').forEach(watchBnpl);

  /* FAQ opens */
  root.querySelectorAll('[data-rm-faq]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) track('beef_share_faq_open', { question: d.getAttribute('data-rm-faq') });
    });
  });

  /* Phone quick picker + sticky Reserve bar (both hidden by CSS at 750px and up).
     Picking a share rewrites the Reserve buttons' data attributes; the add-to-cart
     handler below reads them at click time. */
  if (mode === 'full') document.documentElement.classList.add('rm-bs-landing');
  var quick = root.querySelector('[data-rm-quick]');
  var sticky = root.querySelector('[data-rm-sticky]');
  var reserveBtns = root.querySelectorAll('.rm-bs__quick-add, .rm-bs__sticky-add');
  function pick(input, fromUser) {
    if (!input) return;
    root.querySelectorAll('.rm-bs__pick').forEach(function (l) { l.classList.toggle('is-selected', l.contains(input)); });
    reserveBtns.forEach(function (b) {
      b.setAttribute('data-share', input.value);
      b.setAttribute('data-variant-id', input.getAttribute('data-variant-id'));
      b.setAttribute('data-price', input.getAttribute('data-price'));
      if (b.classList.contains('rm-bs__quick-add')) {
        b.textContent = 'Reserve a ' + input.getAttribute('data-title').toLowerCase() + ' \u00b7 ' + input.getAttribute('data-money');
      }
    });
    if (sticky) {
      var n = sticky.querySelector('[data-rm-sticky-name]'), p = sticky.querySelector('[data-rm-sticky-price]');
      if (n) n.textContent = input.getAttribute('data-title');
      if (p) p.textContent = input.getAttribute('data-money');
    }
    if (fromUser) track('beef_share_pick', { share: input.value, placement: 'quick' });
  }
  if (quick) {
    var radios = quick.querySelectorAll('input[name="rm-bs-pick"]');
    radios.forEach(function (r) { r.addEventListener('change', function () { pick(r, true); }); });
    pick(quick.querySelector('input[name="rm-bs-pick"]:checked'), false);
  }
  if (quick && sticky && 'IntersectionObserver' in window) {
    var stickyIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button'); if (b) b.tabIndex = show ? 0 : -1;
      });
    }, { threshold: 0 });
    stickyIo.observe(quick);
  }

  /* Add to cart: same request Dawn's product form makes, so the cart drawer opens. */
  root.querySelectorAll('[data-rm-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = btn.getAttribute('data-variant-id');
      var share = btn.getAttribute('data-share');
      var price = parseFloat(btn.getAttribute('data-price') || '0');
      var drawer = document.querySelector('cart-drawer');
      var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Reserving…';
      track('beef_share_cta_click', { cta: (btn.getAttribute('data-rm-placement') || 'card') + '-add', share: share });

      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', '1');
      if (drawer) {
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', location.pathname);
      }
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'add failed');
        track('beef_share_add_to_cart', { share: share, variant_id: vid, price: price });
        if (drawer && json.sections && typeof drawer.renderContents === 'function') {
          /* Dawn's product form does this too: an empty drawer uses a centered grid layout
             that hides the line items until the class comes off. */
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
        } else {
          location.href = cartUrl;
        }
      }).catch(function (e) {
        track('beef_share_add_to_cart_error', { share: share, message: String(e && e.message) });
        location.href = cartUrl;
      }).then(function () {
        btn.disabled = false; btn.textContent = orig;
      });
    });
  });
})();
